var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4 0.0171177C49.1785 -0.00570591 48.9552 -0.00570591 48.7337 0.0171177H3.23375C2.94213 0.0216111 2.65245 0.0653369 2.3725 0.147118L25.8537 23.5309L49.4 0.0171177Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.805 2.27588L28.145 25.8384C27.5361 26.4437 26.7124 26.7835 25.8538 26.7835C24.9951 26.7835 24.1714 26.4437 23.5625 25.8384L0.11375 2.45463C0.0416641 2.71957 0.00344286 2.99258 0 3.26713V35.7671C0 36.6291 0.34241 37.4557 0.951903 38.0652C1.5614 38.6747 2.38805 39.0171 3.25 39.0171H48.75C49.612 39.0171 50.4386 38.6747 51.0481 38.0652C51.6576 37.4557 52 36.6291 52 35.7671V3.26713C51.9871 2.92857 51.9213 2.59411 51.805 2.27588ZM5.47625 35.7671H3.2175V33.4434L15.0312 21.7271L17.3225 24.0184L5.47625 35.7671ZM48.7175 35.7671H46.4425L34.5962 24.0184L36.8875 21.7271L48.7012 33.4434L48.7175 35.7671Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1b73b3658b41fd0bdc1c63e357c0f660.svg";
export { ForwardRef as ReactComponent };